import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import { type EditExternalLicensePoolButtonProps } from "./edit-external-license-pool-button.interface";
import { Paths } from "../../../routes/paths";

export const EditExternalLicensePoolButton = ({
	externalLicensePoolId,
}: EditExternalLicensePoolButtonProps) => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();

	return (
		<Button
			icon="pi pi-pencil"
			tooltip={t("externalLicenses.editPoolTooltip")}
			onClick={() => {
				navigate(Paths.externalLicensePools.withId(externalLicensePoolId).edit.path);
			}}
		/>
	);
};
